import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TransferServiceService {
  private data;
  constructor() {
  }

  setData(data) {
    this.data = data;
  }

  getData() {
    const temp = this.data;
    this.clearData();
    return temp;
  }

  clearData() {
    this.data = undefined;
  }
}
